import ResponsibilityName from '../constants/responsibilityNames'
import RoleName from '../constants/roleNames'
import { Nil } from './types'

export type UserPermissions = Record<Lowercase<CRUD>, boolean>

export type BaseRole = {
  businessCategory?: RoleBusinessCategory
  hidden: boolean
  id: string
  name: RoleName
  nameTranslation: string
  remote: boolean
  rhapsodyAnalytics: boolean
  type: RoleType | Nil
}

export type Role = BaseRole & {
  allowedRolesForOtherPersonSet?: string[]
  businessId: string
  permissions: Record<PermissionArea, UserPermissions>
}

export type Responsibility = {
  id: string
  name: ResponsibilityName
  nameTranslation: string
  roles: Role[]
}

export type BackendRole = BaseRole & {
  permissions: Partial<Record<PermissionArea, CRUD[]>>
}

export type BusinessRole = Pick<BaseRole, 'type'> & {
  business: string
  isGroup?: boolean
  role: string
}

export enum PermissionArea {
  ADJUSTMENTS = 'ADJUSTMENTS',
  BODY_SYSTEM = 'BODY_SYSTEM',
  BUNDLE = 'BUNDLE',
  BUSINESS = 'BUSINESS',
  BUSINESS_APPOINTMENT_TYPE = 'BUSINESS_APPOINTMENT_TYPE',
  BUSINESS_GROUP = 'BUSINESS_GROUP',
  CHAT_RECONCILE = 'CHAT_RECONCILE',
  CHEWY_RX_PRESCRIPTION = 'CHEWY_RX_PRESCRIPTION',
  COMMUNICATION = 'COMMUNICATION',
  CONNECT_CHEWY_ACCOUNT = 'CONNECT_CHEWY_ACCOUNT',
  CONTACT = 'CONTACT',
  CREDIT_ADJUSTMENT = 'CREDIT_ADJUSTMENT',
  CUSTOM_QUESTION = 'CUSTOM_QUESTION',
  DASHBOARD = 'DASHBOARD',
  DIAGNOSE = 'DIAGNOSE',
  DISCOUNT = 'DISCOUNT',
  EVENT_APPOINTMENT = 'EVENT_APPOINTMENT',
  EVENT_AVAILABILITY = 'EVENT_AVAILABILITY',
  FORM = 'FORM',
  IMAGE_FILE = 'IMAGE_FILE',
  IMPORT = 'IMPORT',
  INVENTORY = 'INVENTORY',
  INVENTORY_BULK_PRICE = 'INVENTORY_BULK_PRICE',
  INVOICE = 'INVOICE',
  INVOICE_DOCTOR = 'INVOICE_DOCTOR',
  KYRIOS_CLINIC_ID = 'KYRIOS_CLINIC_ID',
  LAB_TEST = 'LAB_TEST',
  LAB_TEST_BULK_PRICE = 'LAB_TEST_BULK_PRICE',
  LAB_TEST_PRICE = 'LAB_TEST_PRICE',
  MARKETPLACE = 'MARKETPLACE',
  MARKETPLACE_AND_INTEGRATIONS = 'MARKETPLACE_AND_INTEGRATIONS',
  MEMBERSHIP_LINK = 'MEMBERSHIP_LINK',
  PATIENT = 'PATIENT',
  PAYMENT = 'PAYMENT',
  PAYMENT_DEVICE = 'PAYMENT_DEVICE',
  PERSON = 'PERSON',
  PERSON_ASSIGNED_ROLES = 'PERSON_ASSIGNED_ROLES',
  PRACTICES = 'PRACTICES',
  PRESCRIPTION = 'PRESCRIPTION',
  PROCEDURE = 'PROCEDURE',
  PROCEDURE_BULK_PRICE = 'PROCEDURE_BULK_PRICE',
  PROCEDURE_PRICE = 'PROCEDURE_PRICE',
  PROTOCOL = 'PROTOCOL',
  REASON_FOR_DISCOUNT = 'REASON_FOR_DISCOUNT',
  REINDEX = 'REINDEX',
  REMINDERS = 'REMINDERS',
  REMINDER_PROTOCOLS = 'REMINDER_PROTOCOLS',
  REPORTING = 'REPORTING',
  RESERVED_BLOCK = 'RESERVED_BLOCK',
  SHIPMENTS = 'SHIPMENTS',
  SOAP = 'SOAP',
  SOAP_TEMPLATE = 'SOAP_TEMPLATE',
  SPACE = 'SPACE',
  SSO_SETTINGS = 'SSO_SETTINGS',
  SUPPORT = 'SUPPORT',
  TASK = 'TASK',
  VITAL = 'VITAL',
  WELLNESS_PLAN = 'WELLNESS_PLAN',
  WELLNESS_PLAN_CONFIG = 'WELLNESS_PLAN_CONFIG',
  // analytics portal related permissions
  ANALYTICS_REPORTS = 'ANALYTICS_REPORTS',
  BENCHMARKING_LIGHT = 'BENCHMARKING_LIGHT',
  BENCHMARKING_PLUS = 'BENCHMARKING_PLUS',
  GROUP_REPORTS = 'GROUP_REPORTS',
  MARKETING_REPORTS = 'MARKETING_REPORTS',
  PIMS = 'PIMS',
  SELF_SERVE_PORTAL = 'SELF_SERVE_PORTAL',
}

export enum CRUD {
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  SIGN = 'SIGN',
  SEND = 'SEND',
}

export enum RoleType {
  STAFF_ROLE = 'B2B',
  CLIENT_ROLE = 'B2C',
}

export enum RoleBusinessCategory {
  ALL = 'ALL',
  CVC = 'CVC',
  THIRD_PARTY = 'THIRD_PARTY',
}
